<template>
  <div>
    <template v-for="(item, index) in orderDetail" :key="index">
      <!-- 车次信息 -->
      <div>
        <div class="trainInfo">
          <div class="title">
            车次信息{{ '（ ' + orderDetail[0].orderStateValue + ' ）' }}
          </div>
          <a-row class="main">
            <a-col :span="13">
              <div class="top">{{ item.fromTimeFormat }} 出发</div>
              <a-row class="box">
                <a-col :span="8">
                  <div class="time">{{ item.fromTime }}</div>
                  <div class="city">{{ item.fromStation }}</div>
                </a-col>
                <a-col :span="8" class="maiddle">
                  <div class="runTime">
                    {{ item.takeTimeFormat }}
                    <img src="@assets/img/idcard.png" />
                  </div>
                  <img src="@assets/img/cardline.png" />
                  <div class="trainNo">{{ item.trainNo }}</div>
                </a-col>
                <a-col :span="8" class="right">
                  <div class="time">{{ item.toTime }}</div>
                  <div class="city">{{ item.toStation }}</div>
                </a-col>
              </a-row>
              <div class="bottom">
                <span v-if="item.ticketCheck">{{
                  '检票口：' + item.ticketCheck
                }}</span>
              </div>
            </a-col>
            <a-col :span="11" v-if="!showLoadingOut(item)">
              <a-row class="item">
                <a-col :span="12" class="totle_price">总额</a-col>
                <a-col :span="12" class="price">¥{{ item.totalAmount }}</a-col>
              </a-row>
              <a-row
                class="item"
                v-for="(value, key) in finishing(item)"
                :key="key"
              >
                <a-col :span="12">火车票（ {{ typeName[key] }} ）</a-col>
                <a-col :span="12" class="price"
                  >¥{{ value.ticketLastPrice }} x {{ value.num }}张</a-col
                >
              </a-row>
            </a-col>
            <a-col :span="11" v-else class="loading_cont">
              <a-button type="primary" class="loading_btn" loading>
                {{ showLoadingOut(item) }}
              </a-button>
            </a-col>
          </a-row>
        </div>
        <!-- 乘客信息 -->
        <div class="passengerInfo">
          <a-row class="title">
            <a-col :span="12">
              <div class="title-left">乘客信息</div>
            </a-col>
          </a-row>
          <a-row
            class="main"
            v-for="(data, dataIndex) in item.passengersList"
            :key="dataIndex"
          >
            <a-col :span="4" class="name">
              {{ data.passengerName }}
            </a-col>
            <a-col :span="4" class="type">{{ data.passengerTypeValue }}</a-col>
            <a-col :span="7">
              {{ data.seatName }}
              {{ data.lastCoach }}
              {{ data.lastSeat }}
            </a-col>
            <a-col :span="4">
              <span
                v-if="
                  data.state == 10 ||
                  data.state == 20 ||
                  data.state == 30 ||
                  data.state == 40
                "
                >{{ data.stateValue }}</span
              >
              <span v-else>正常票</span>
            </a-col>
            <a-col :span="5" class="price">¥{{ data.ticketLastPrice }}</a-col>
          </a-row>
        </div>
        <!-- 保险 -->
        <div
          class="passengerInfo insurance"
          v-if="
            orderDetail[0].orderPassengersInsurance &&
            orderDetail[0].orderPassengersInsurance.length > 0
          "
        >
          <a-row class="title">
            <a-col :span="24">
              <div class="title-left">保险信息</div>
            </a-col>
          </a-row>
          <a-row
            class="main"
            v-for="(data, dataIndex) in orderDetail[0].orderPassengersInsurance"
            :key="dataIndex"
            :class="{
              grayClass: data.returnState >= 30 || data.insuranceState >= 31,
            }"
          >
            <a-col :span="4" class="name">
              {{ data.orderPassengerName }}
            </a-col>
            <a-col :span="4" class="name">{{ data.insuranceName }}</a-col>
            <a-col :span="10">
              保单：
              {{ data.insureNo }}
            </a-col>
            <a-col
              :span="3"
              class="price"
              v-if="data.insuranceState !== 31"
              style="color: #ff0000"
            >
              <span>{{ data.stateValue }}</span>
            </a-col>
            <a-col :span="3" class="price" v-else style="color: #f7b500">
              <WarningOutlined style="margin-right: 2px" />
              <span>{{ data.stateValue }}</span>
            </a-col>
            <a-col :span="3" class="price regular">
              ¥{{ data.insuranceAmount }}
            </a-col>
          </a-row>
        </div>
        <!-- btn -->
        <div class="bottomInfo" v-show="item.cardActionType">
          <div class="handleBtn" @click="toRefund">
            立即{{ item.cardActionType == 1 ? '改签' : '退票' }}
          </div>
        </div>
      </div>
    </template>
    <div class="card_content" v-if="orderDetail[0].remark">
      <div class="icon">
        <WarningOutlined :style="{ color: '#FD5739', size: '20px' }" />
      </div>
      <div class="tips">
        {{ orderDetail[0].remark }}
      </div>
    </div>

    <div class="money_content" v-if="orderDetail[0].id">
      <div>
        <div class="price" v-if="orderDetail[0].returnAmount !== null">
          <div>退还原票票款</div>
          <div class="light">¥{{ orderDetail[0].returnAmount }}</div>
        </div>
        <div class="price" v-if="orderDetail[0].differenceAmount !== null">
          <div>退回票款</div>
          <div class="light">¥{{ orderDetail[0].differenceAmount }}</div>
        </div>
        <div class="price" v-if="orderDetail[0].insuranceAmount !== null">
          <div>退回保险费用</div>
          <div class="light">¥{{ orderDetail[0].insuranceAmount }}</div>
        </div>
        <!-- <div class="price" v-if="orderDetail[0].newAmount !== null">
          <div>收取新票票款</div>
          <div class="light">¥{{ orderDetail[0].newAmount }}</div>
        </div> -->
        <div class="price" v-if="orderDetail[0].refundTicketRate !== ''">
          <div>退票税率</div>
          <div class="light">{{ orderDetail[0].refundTicketRate }}</div>
        </div>
        <div class="price" v-if="orderDetail[0].refundTicketAmount !== null">
          <div>退票费</div>
          <div class="light">¥{{ orderDetail[0].refundTicketAmount }}</div>
        </div>

        <div
          class="price_totle"
          v-if="orderDetail[0].actualReturnAmount !== null"
        >
          <div>实际退还票款</div>
          <div style="color: #fd5739">
            ¥{{ orderDetail[0].actualReturnAmount }}
          </div>
        </div>
      </div>
    </div>

    <div class="confirm_order" v-show="orderDetail[0].orderState == 30">
      <a-button type="primary" class="submitBtn" @click="confirmOrder">
        确认改签
      </a-button>
      <a-button type="primary" class="concelBtn" @click="cancelOrder">
        取消改签
      </a-button>
    </div>
  </div>
</template>
<script>
import { ref, watch } from 'vue'
import commonApi from '@axios/common'
import { useRouter, useRoute } from 'vue-router'
import { MailOutlined, AppstoreOutlined, SettingOutlined, WarningOutlined } from '@ant-design/icons-vue'
import homeApi from '@axios/home'
import { Modal, message } from 'ant-design-vue'
let timer
export default {
  name: 'endorsed',
  components: {
    MailOutlined,
    AppstoreOutlined,
    SettingOutlined,
    WarningOutlined,
  },
  setup () {
    let router = useRouter()
    const route = useRoute()

    let orderCode = route.query.orderCode

    let orderDetail = ref([{
      orderBoList: [],
      passengersList: []
    }])

    const getOrderDetail = () => {
      homeApi.changeOrderDetail(orderCode).then((res) => {


        orderDetail.value = [res]
      })
    }


    getOrderDetail()


    // 乘客信息
    let passengerChecked = ref(false)
    const passengerChange = (e) => {
      console.log(e.target.checked)
    }


    const showLoadingOut = (item) => {

      if (item.orderState < 50 && item.orderState != 30) {
        //刷无疑
        setReload()
        return item.orderStateValue
      } else {

        //如果不是主订单状态 查乘客状态有没有
        for (var i = 0; i < item.passengersList.length; i++) {

          if (item.passengersList[i].state == 10 || item.passengersList[i].state == 20) {

            setReload()
            return item.passengersList[i].stateValue
          }
        }
      }

      return ''
    }


    const setReload = () => {
      if (timer) clearInterval(timer)
      timer = setTimeout(() => {
        getOrderDetail()
      }, 5000)
    }

    const finishing = (item) => {
      let obj = {}
      item.passengersList.forEach(element => {
        if (element.passengerType === 1) {
          if (obj.adultList) {
            obj.adultList.num++

          } else {
            obj.adultList = {
              num: 1,
              ticketLastPrice: element.ticketLastPrice
            }
          }

        } else if (element.passengerType === 2) {
          if (obj.childList) {
            obj.childList.num++
          } else {
            obj.childList = {
              num: 1,
              ticketLastPrice: element.ticketLastPrice
            }
          }
        } else if (element.passengerType === 3) {
          if (obj.studentList) {
            obj.studentList.num++
          } else {
            obj.studentList = {
              num: 1,
              ticketLastPrice: element.ticketLastPrice
            }
          }
        } else if (element.passengerType === 4) {
          if (obj.disabilityList) {
            obj.disabilityList.num++
          } else {
            obj.disabilityList = {
              num: 1,
              ticketLastPrice: element.ticketLastPrice
            }
          }
        }

      })
      return obj
    }

    let typeName = {
      adultList: '成人票',
      childList: '儿童票',
      studentList: '学生票',
      disabilityList: '残军票',
    }


    const cancelOrder = () => {
      let params = {
        orderCode: orderDetail.value[0].orderCode
      }

      Modal.confirm({
        content: '请再次确认是否取消？',
        onOk () {
          homeApi.cancelOrder(params).then((res) => {
            getOrderDetail()
          })
        },
        cancelText: "取消",
        okText: "确定",
        onCancel () {
          Modal.destroyAll()
        },
      })


    }

    const confirmOrder = () => {
      // let params = {
      //   orderCode : orderDetail.value[0].orderCode
      // }

      // homeApi.confirmOrder(params).then((res)=>{
      //   getOrderDetail()
      // })

      let params = {
        orderCode: orderDetail.value[0].orderCode,
        appPlatform: 10,
        returnUrl: window.location.href
      }

      homeApi.goPay(params).then((res) => {

        window.location.href = res.cashierUrl + '?advanceOrderNo=' + res.advanceOrderNo + '&type=train'  //为了支付完回跳。。暂时只有火车票业务其实用不上 type=train
      })


    }


    return {
      cancelOrder,
      confirmOrder,
      typeName,
      finishing,
      showLoadingOut,
      orderDetail,
      passengerChecked,
      passengerChange

    }
  },

}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.money_content {
  display: flex;
  justify-content: flex-end;
  margin-top: 40px;

  .price,
  .price_totle {
    display: flex;
    width: 335px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    justify-content: space-between;
    line-height: 30px;
    border-bottom: 0.5px dashed #bdc0c8;
    padding: 5px 0;
  }
  .price {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #000000;
  }
  .price_totle {
    border: none;

    font-size: 14px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #000000;
  }
}
.totle_price {
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #000000;
}
.regular {
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
}
.totle_price {
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #000000;
}
.regular {
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
}
.confirm_order {
  margin-top: 70px;
  display: flex;
  justify-content: flex-end;
  .submitBtn,
  .concelBtn {
    width: 167px;
    height: 40px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    font-family: PingFangSC-Regular, PingFang SC;
    font-size: 16px;
  }
  .submitBtn {
    background: #ffab00;
    border-color: #ffab00;
    margin-right: 17px;
  }
  .concelBtn {
    background: #f8f8f8;
    border-color: #f8f8f8;
    color: #000000;
  }
}

.loading_cont {
  ::v-deep(.ant-btn.ant-btn-loading)::before {
    display: none !important;
  }
}

.loading_btn {
  background: #ffab00;
  border-color: #ffab00;
  width: 125px;
  height: 35px;
  cursor: wait;
}
.loading_cont {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
.endorse_cont {
  margin-top: 100px;
}
.grayClass {
  color: #dedfe3 !important;
  .price,
  .type {
    color: #dedfe3 !important;
  }
}
.name {
  display: flex;
  justify-content: flex-start;
  align-items: center;

  font-family: PingFangSC-Medium, PingFang SC;
  span {
    margin-right: 10px;
  }
}
.orderDetail {
  width: 1200px;
  margin: 0 auto;
  padding: 25px 15px;
  box-sizing: border-box;
  font-size: 14px;
}
.topTitle {
  line-height: 20px;
  margin-bottom: 20px;
  span {
    margin: 0 2px;
  }
}

.trainInfo {
  border: 0.5px solid #cdcccd;
  .title {
    height: 68px;
    line-height: 68px;
    font-size: 16px;
    padding-left: 26px;
    border-bottom: 0.5px solid #cdcccd;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
  }
  .main {
    padding: 15px 33px;
    display: flex;
    justify-content: flex-start;
    height: 180px;

    .ant-col-13 {
      border-right: 0.5px solid #cdcccd;
      .top {
        font-size: 16px;
        line-height: 22px;
        margin-bottom: 9px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #000000;
      }
      .box {
        padding-right: 40px;
        .time {
          line-height: 28px;
          margin-bottom: 8px;

          font-size: 20px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #000000;
        }
        .city {
          line-height: 22px;

          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
        }
        .maiddle {
          text-align: center;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          & > img {
            width: 95px;
          }
          .runTime {
            font-size: 14px;
            line-height: 20px;
            color: #000000;

            font-family: PingFangSC-Light, PingFang SC;
            img {
              width: 17px;
              position: relative;
              top: -1px;
            }
          }
          .trainNo {
            line-height: 28px;
            font-size: 20px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #fd5839;
          }
        }
        .right {
          text-align: right;
        }
      }
      .bottom {
        padding-right: 40px;
        text-align: right;
        margin-top: 18px;
        span {
          font-size: 12px;
          color: #3999fb;
          border: 0.5px solid #3999fb;
          border-radius: 10px;
          padding: 1px 8px;
        }
      }
    }
    .ant-col-11 {
      padding: 31px 47px;
      .item {
        line-height: 26px;
        margin-bottom: 8px;
        .price {
          text-align: right;
          font-size: 16px;
          font-family: PingFangSC-Light, PingFang SC;
          font-weight: 300;
          color: #000000;
        }
      }
    }
  }
}
.passengerInfo {
  background: rgba(248, 248, 248, 1);
  padding: 20px 10px;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.1);
  .title {
    padding-right: 47px;
    .title-left {
      font-size: 16px;
      line-height: 22px;
      padding: 0 21px;
      margin-bottom: 18px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #000000;
    }
    .title-right {
      text-align: right;
      .change {
        font-size: 14px;
        cursor: pointer;
      }
      .line {
        margin: 0 20px;
        color: rgba(0, 0, 0, 0.35);
      }
      .choosed {
        color: #ffab00;
        text-decoration: underline;
      }
      .refund {
        cursor: pointer;
      }
    }
  }
  .main {
    padding: 5px 47px 5px 21px;
    // height: 40px;
    line-height: 40px;
    font-size: 16px;
    border-bottom: 0.5px dashed rgba(189, 192, 200, 0.5);
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 300;
    color: #000000;
    &:last-of-type {
      border-bottom: none;
    }
    .type {
      font-size: 14px;
      color: #6d7278;
    }
    .price {
      text-align: right;
      color: #ff0000;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
    }
  }
}
.insurance {
  background: #ffffff;
  padding: 15px 10px;
  .title {
    .title-left {
      font-size: 14px;
      line-height: 20px;
      margin-bottom: 0;
    }
  }
  .main {
    line-height: 30px;
    font-size: 14px;
  }
}
.noendorse {
  color: #dedfe3 !important;
}
.bottomInfo {
  text-align: right;
  margin: 20px 0 60px 0;
  .handleBtn {
    display: inline-block;
    padding: 9px 50px;
    background: #ffab00;
    font-size: 16px;
    color: #ffffff;
    border-radius: 4px;
    cursor: pointer;
  }
}
</style>
